import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { useQuery } from "@tanstack/react-query";
import styled from "@emotion/styled";
import "react-datetime/css/react-datetime.css";
import { setColor } from "../../../../../assets/styles/styles";
import Typography from "../../../../../components/common/text/Typography";
import Banner from "../../../../../components/layout/ui/Banner";
import { default as Button } from "../../../../../components/common/button/Button";
import {
    getUserGroups,
    getRoomById,
    getRoomSettingsById,
    getRoomTags,
    getRoomPrefabs,
    updateRoom,
    updateRoomImages,
    updateRoomSettingsById,
} from "../../rooms/api/roomController";
import { CACHE_QUERY_OPTIONS, DEFAULT_QUERY_OPTIONS } from "../../../../../constants";
import Dropdown from "../../../../../components/common/inputDropdown/Dropdown";
import UserSearchDropdown from "../../../components/UserSearchDropdown";
import ToggleSwitch from "../../../../../components/common/switchToggle/ToggleSwitch";
import LoadingIcon from "../../../../../components/common/loading/LoadingIcon";
import {
    updateVanityLink,
    updateVanityLinkDataImages,
    updateVanityLinkData,
    fetchVanityLinkData,
    fetchAllAvatarPresets,
} from "../../../../../api/VanityLinkController";
import { ReactComponent as Checkmark } from "../../../../../assets/images/icons/Checkmark.svg";
import { ReactComponent as Cross } from "../../../../../assets/images/icons/Cross.svg";
import { getFileUrl } from "../../../../../api/FilesController";
import UploadFile from "../../../../../components/common/fileUploader/FileUploaderInput";
import Modal from "../../../components/Modal";
import JsonViewerModal from "./JsonViewerModal";
import AddRoomTypeModal from "../../../components/AddRoomTypeModal";
import UpdateRoomPrefabModal from "../../../components/UpdateRoomPrefabModal";
import { getAllKeybinds } from "../../../../../api/ClientsTagController";

const EditLinkModal = ({ data }) => {
    const token = useSelector((state) => state?.user?.token);
    const [roomId, setRoomId] = useState(data?.roomId);
    const [vanityId, setVanityId] = useState(data?.vanityId);
    const [activeTab, setActiveTab] = useState("ROOM");
    const tabs = ["ROOM", "ROOM SETTINGS", "VANITY LINK", "VANITY LINK DATA"];
    const [loading, setLoading] = useState(false);
    const [APIFailed, setAPIFailed] = useState(false);
    const [bannerMessage, setBannerMessage] = useState("Error updating data");

    // Rooms
    const [selectedRoomTags, setSelectedRoomTags] = useState([]);
    const [isSuccess, setIsSuccess] = useState(false);
    const [isError, setIsError] = useState(false);
    const [selectedGroupLabel, setSelectedGroupLabel] = useState("");
    const [selectedBannerImage, setSelectedBannerImage] = useState(null);
    const [selectedRoomDetailsImage, setSelectedRoomDetailsImage] = useState(null);
    const [selectedRoomOwnerImage, setSelectedRoomOwnerImage] = useState(null);
    const [openRoomTypeModal, setOpenRoomTypeModal] = useState(false);
    const [openRoomPrefabModal, setOpenRoomPrefabModal] = useState(false);
    const [roomState, setRoomState] = useState({
        name: "",
        description: "",
        roomType: "",
        json: {},
        ownerId: "",
        tags: [],
        groupId: "",
        groupName: "",
        clientTag: "",
        isVisibleInNavMenu: false,
        bannerImageKey: null,
        roomDetailsImageId: null,
        roomOwnerImageId: null,
        ownerName: "",
        bannerImageFile: null,
        roomDetailsImageFile: null,
        roomOwnerImageFile: null,
    });

    const [initialRoomState, setInitialRoomState] = useState(null);

    // Room Settings
    const [tooglesLdr, setTooglesLdr] = useState({
        voiceChatEnabled: false,
        leaderboardsEnabled: false,
        spotifyEnabled: false,
        ecommerceEnabled: false,
        settingsMenuEnabled: false,
        canReturnToNavMenuEnabled: false,
        textChatEnabled: false,
        showEmoteWheel: false,
        showFriends: false,
    });
    const [tooglesErr, setTooglesErr] = useState({
        voiceChatEnabled: "",
        leaderboardsEnabled: "",
        spotifyEnabled: "",
        ecommerceEnabled: "",
        settingsMenuEnabled: "",
        canReturnToNavMenuEnabled: "",
        textChatEnabled: "",
        showEmoteWheel: "",
        showFriends: "",
    });

    const [tooglesSucs, setTooglesSucs] = useState({
        voiceChatEnabled: "",
        leaderboardsEnabled: "",
        spotifyEnabled: "",
        ecommerceEnabled: "",
        settingsMenuEnabled: "",
        canReturnToNavMenuEnabled: "",
        textChatEnabled: "",
        showEmoteWheel: "",
        showFriends: "",
    });
    const [errorMessage, setErrorMessage] = useState(false);
    const [successMessage, setSuccessMessage] = useState(false);
    const [roomSettingsId, setRoomSettingsId] = useState(null);
    const [voiceChatEnabled, setVoiceChatEnabled] = useState(false);
    const [leaderboardsEnabled, setLeaderboardsEnabled] = useState(false);
    const [spotifyEnabled, setSpotifyEnabled] = useState(false);
    const [ecommerceEnabled, setEcommerceEnabled] = useState(false);
    const [settingsMenuEnabled, setSettingsMenuEnabled] = useState(false);
    const [canReturnToNavMenuEnabled, setCanReturnToNavMenuEnabled] = useState(false);
    const [textChatEnabled, setTextChatEnabled] = useState(false);
    const [privacy, setPrivacy] = useState("public");
    const [showEmoteWheel, setShowEmoteWheel] = useState(false);
    const [showFriends, setShowFriends] = useState(false);
    const [currentField, setCurrentField] = useState(null);
    const [currentFieldLabel, setCurrentFieldLabel] = useState(null);
    const [isJsonEditorOpen, setIsJsonEditorOpen] = useState(false);
    const [jsonEditorValue, setJsonEditorValue] = useState("");
    const [spotifyTrackVal, setSpotifyTrackVal] = useState("");
    const [broadcastIdVal, setBroadcastIdVal] = useState("");
    const [showUpdateButtonSpotify, setShowUpdateButtonSpotify] = useState(false);
    const [showUpdateButtonBroad, setShowUpdateButtonBroad] = useState(false);
    const [showUpdateKeybind, setShowUpdateKeybind] = useState(false);
    const [selectedAvatars, setSelectedAvatars] = useState(() => {
        return data?.presetAvatarIds?.map((avatar) => avatar.id) ?? [];
    });
    const [keyOptions, setKeyOptions] = useState([]);
    const [valueOptions, setValueOptions] = useState([]);

    const { data: keybindsData, isLoading: roomPresetsLoading } = useQuery(
        ["keybindsOptions"], // Query key, add params if needed
        () => getAllKeybinds(), // Query function
        {
            ...DEFAULT_QUERY_OPTIONS(),
        }
    );
    useEffect(() => {
        if (keybindsData) {
            setKeyOptions(keybindsData.data.keyOptions || []);
            setValueOptions(keybindsData.data.valueOptions || []);
        }
    }, [keybindsData]);

    // Sync selectedAvatars when data prop changes
    useEffect(() => {
        if (data?.presetAvatarIds) {
            setSelectedAvatars(data.presetAvatarIds.map((avatar) => avatar.id) ?? []);
        }
    }, [data?.presetAvatarIds]);

    const [newKey, setNewKey] = useState("");
    const [newValue, setNewValue] = useState("");
    const [presetKeybinds, setPresetKeybinds] = useState({});

    // Vanity Links
    const [originalVanityData, setOriginalVanityData] = useState(data);
    const [vanityLinkName, setVanityLinkName] = useState(data?.vanityLink);
    const [isJsonEditorOpenVanity, setIsJsonEditorOpenVanity] = useState(false);
    const [freeFormJson, setFreeFormJson] = useState(JSON.stringify(data?.freeformJson) || {});
    const [staticUrl, setStaticUrl] = useState(data?.staticUrl);
    const [applicationId, setApplicationId] = useState(data?.applicationId);

    // VANITY LINK DATA
    const [selectedBGImg, setSelectedBGImg] = useState(null);
    const [selectedMiscImg, setSelectedMiscImg] = useState(null);
    const [selectedClientImg, setSelectedClientImg] = useState(null);
    const [selectedClientLogoImg, setSelectedClientLogoImg] = useState(null);
    const [bGUrl, setBGUrl] = useState("");
    const [clientUrl, setClientUrl] = useState("");
    const [otherLoginUrl, setOtherLoginUrl] = useState("");
    const [miscImageUrl, setMiscImageUrl] = useState("");
    const [clientName, setClientName] = useState("");
    const [isJsonEditorOpenLinkData, setIsJsonEditorOpenLinkData] = useState(false);
    const [jsonEditorValueLinkData, setJsonEditorValueLinkData] = useState("");
    const [freeFormJsonLinkData, setFreeFormJsonLinkData] = useState("");
    const [ssoMetadataJson, setSsoMetadataJson] = useState("");
    const [isJsonEditorOpenSSO, setIsJsonEditorOpenSSO] = useState(false);
    const [emailLoginEnabled, setEmailLoginEnabled] = useState(true);
    const [fbLoginEnabled, setFbLoginEnabled] = useState(false);
    const [googleLoginEnabled, setGoogleLoginEnabled] = useState(false);
    const [twiiterLoginEnabled, setTwiiterLoginEnabled] = useState(false);
    const [spotifyLoginEnabled, setSpotifyLoginEnabled] = useState(false);
    const [otherLoginEnabled, setOtherLoginEnabled] = useState(false);
    const [sso, setSso] = useState(false);
    const [broadcast, setBroadcast] = useState(false);
    const [ambientTrackId, setAmbientTrackId] = useState("");
    const [guestOnlyMode, setGuestOnlyMode] = useState(false);
    const [marketingOptIn, setMarketingOptIn] = useState(false);
    const [originalLinksData, setOriginalLinksData] = useState({});

    // apis based on active tab
    const { data: userGroups } = useQuery(["userGroups"], getUserGroups, {
        ...CACHE_QUERY_OPTIONS(),
        enabled: activeTab === "ROOM",
    });

    const { data: roomTags } = useQuery(["roomTags"], getRoomTags, {
        ...CACHE_QUERY_OPTIONS(),
        enabled: activeTab === "ROOM",
    });

    const { data: roomPrefabs, refetch } = useQuery(["roomPrefabs"], getRoomPrefabs, {
        ...CACHE_QUERY_OPTIONS(),
        enabled: activeTab === "ROOM",
    });

    const {
        data: roomData,
        isLoading: roomLoading,
        refetch: refetchRoomData,
    } = useQuery(["roomData", roomId], () => getRoomById(roomId), {
        enabled: activeTab === "ROOM",
        onSuccess: (roomData) => {
            if (roomData) {
                setSelectedRoomTags(roomData.tagsNames);
                setSelectedGroupLabel(roomData.userGroup);
                const mappedTags =
                    roomTags
                        ?.filter((tag) => roomData?.tags.includes(tag.id))
                        .map((tag) => ({
                            id: tag.id,
                            value: tag.label,
                        })) || [];
                const updatedRoomData = {
                    name: roomData.name,
                    description: roomData.description,
                    roomType: roomData.roomType,
                    json: roomData.json,
                    ownerId: roomData.ownerId,
                    tags: mappedTags,
                    groupId: roomData.groupId,
                    groupName: roomData.userGroup,
                    isVisibleInNavMenu: roomData.isVisibleInNavMenu,
                    bannerImageKey: roomData.bannerImageKey,
                    roomDetailsImageId: roomData.roomDetailsImageId,
                    roomOwnerImageId: roomData.roomOwnerImageId,
                    ownerName: roomData.ownerName,
                    clientTag: roomData.clientTag,
                };

                setRoomState(updatedRoomData);
                setInitialRoomState(updatedRoomData);
            }
        },
    });

    const {
        data: roomSettingsData,
        isLoading: roomSettingsLoading,
        refetch: refetchRoomSettingsData,
    } = useQuery(["roomSettingsData", roomId], () => getRoomSettingsById(roomId), {
        enabled: activeTab === "ROOM SETTINGS",
        onSuccess: (roomSettingsData) => {
            if (roomSettingsData) {
                setRoomSettingsId(roomSettingsData.roomSettingsId);
                setVoiceChatEnabled(roomSettingsData.voiceChatEnabled);
                setLeaderboardsEnabled(roomSettingsData.leaderboardsEnabled);
                setSpotifyEnabled(roomSettingsData.spotifyEnabled);
                setEcommerceEnabled(roomSettingsData.ecommerceEnabled);
                setSettingsMenuEnabled(roomSettingsData.settingsMenuEnabled);
                setCanReturnToNavMenuEnabled(roomSettingsData.canReturnToNavMenuEnabled);
                setPrivacy(roomSettingsData.privacy);
                setJsonEditorValue(JSON.stringify(roomSettingsData.products, null, 2));
                setSpotifyTrackVal(roomSettingsData.spotifyTrack);
                setBroadcastIdVal(roomSettingsData.broadcastId);
                setTextChatEnabled(roomSettingsData.textChatEnabled);
                setShowEmoteWheel(roomSettingsData.showEmoteWheel);
                setShowFriends(roomSettingsData.showFriends);
                setPresetKeybinds(roomSettingsData.keybindsPreset);
            }
        },
    });

    const {
        data: avatarPresets,
        error: errPresets,
        isLoading: avatarPresetsLoading,
        refetch: refetchAvatarPresets,
    } = useQuery(["avatarPresets"], fetchAllAvatarPresets, {
        ...CACHE_QUERY_OPTIONS(),
        enabled: activeTab === "VANITY LINK",
    });

    const {
        data: vanityLinkData,
        isLoading: vanityLinkDataLdng,
        refetch: vanityLinkDataRefetch,
    } = useQuery(["vanityLinkData", data?.vanityLink], () => fetchVanityLinkData(data?.vanityLink), {
        enabled: activeTab === "VANITY LINK DATA",
        onSuccess: (vanityLinkData) => {
            if (vanityLinkData.data) {
                setOriginalLinksData(vanityLinkData.data);
                setClientName(vanityLinkData.data.clientName);
                setSsoMetadataJson(JSON.stringify(vanityLinkData.data.ssoMetadataJson, null, 2));
                setFreeFormJsonLinkData(JSON.stringify(vanityLinkData.data.freeformJson, null, 2));
                setSso(vanityLinkData.data.sso);
                setBroadcast(vanityLinkData.data.broadcast);
                setAmbientTrackId(vanityLinkData.data.ambientTrackId);
                setGuestOnlyMode(vanityLinkData.data.guestOnlyMode);
                setMarketingOptIn(vanityLinkData.data.marketingOptIn);
                setEmailLoginEnabled(vanityLinkData.data.emailLogin);
                setFbLoginEnabled(vanityLinkData.data.fbLogin);
                setGoogleLoginEnabled(vanityLinkData.data.googleLogin);
                setTwiiterLoginEnabled(vanityLinkData.data.twitterLogin);
                setSpotifyLoginEnabled(vanityLinkData.data.spotifyLogin);
                setOtherLoginEnabled(vanityLinkData.data.otherLogin);
                setBGUrl(vanityLinkData.data.backgroundImage);
                setClientUrl(vanityLinkData.data.clientLogo);
                setOtherLoginUrl(vanityLinkData.data.otherLoginImage);
                setMiscImageUrl(vanityLinkData.data.miscImageKey);
            } else {
                setIsError(true);
                setAPIFailed(true);
                setBannerMessage("Failed to get data vanity link data");
            }
        },
    });

    // Use query for each image key
    const { data: bannerImageUrl } = useQuery(
        ["file", roomData?.bannerImageKey],
        () => getFileUrl(roomData?.bannerImageKey),
        {
            enabled: activeTab === "ROOM" && Boolean(roomData?.bannerImageKey), // Explicit boolean conversion
        }
    );

    const { data: roomDetailsImageUrl } = useQuery(
        ["file", roomData?.roomDetailsImageId],
        () => getFileUrl(roomData?.roomDetailsImageId),
        {
            enabled: activeTab === "ROOM" && Boolean(roomData?.roomDetailsImageId), // Explicit boolean conversion
        }
    );

    const { data: roomOwnerImageUrl } = useQuery(
        ["file", roomData?.roomOwnerImageId],
        () => getFileUrl(roomData?.roomOwnerImageId),
        {
            enabled: activeTab === "ROOM" && Boolean(roomData?.roomOwnerImageId), // Explicit boolean conversion
        }
    );

    useEffect(() => {
        if (isSuccess || isError) {
            const timer = setTimeout(() => {
                setIsSuccess(false);
                setIsError(false);
                setTooglesErr({
                    voiceChatEnabled: "",
                    leaderboardsEnabled: "",
                    spotifyEnabled: "",
                    ecommerceEnabled: "",
                    settingsMenuEnabled: "",
                    canReturnToNavMenuEnabled: "",
                    textChatEnabled: "",
                    showEmoteWheel: "",
                    showFriends: "",
                });
                setTooglesSucs({
                    voiceChatEnabled: "",
                    leaderboardsEnabled: "",
                    spotifyEnabled: "",
                    ecommerceEnabled: "",
                    settingsMenuEnabled: "",
                    canReturnToNavMenuEnabled: "",
                    textChatEnabled: "",
                    showEmoteWheel: "",
                    showFriends: "",
                });
            }, 3000);
            return () => clearTimeout(timer);
        }
    }, [isSuccess, isError]);

    const handleAddRoomTypeClick = () => {
        setOpenRoomTypeModal(true);
    };

    const handleRoomPrefabClick = () => {
        setOpenRoomPrefabModal(true);
    };

    const setRoomType = (value) => {
        updateRoomState("roomType", value);
        setOpenRoomTypeModal(false);
    };

    const handleUserClickOwner = (option) => {
        updateRoomState("ownerId", option.userId);
    };

    const handleRemoveTag = (tag) => {
        const filteredTags = selectedRoomTags.filter((selectedTag) => selectedTag.value !== tag.value);
        setSelectedRoomTags(filteredTags);

        setRoomState((prevDetails) => ({
            ...prevDetails,
            tags: filteredTags.map((tag) => tag.value).join(","), // or leave as array
        }));
        updateRoomState("tags", filteredTags);
    };

    const handleRoomTagsClick = (option) => {
        if (selectedRoomTags.find((tag) => tag.value === option.value)) return; // prevent duplicates

        const newSelectedTags = [...selectedRoomTags, option];
        setSelectedRoomTags(newSelectedTags);

        setRoomState((prevDetails) => ({
            ...prevDetails,
            tags: newSelectedTags.map((tag) => tag.value).join(","), // or leave as array
        }));
        updateRoomState("tags", newSelectedTags);
    };

    const setRoomGroupId = (option) => {
        updateRoomState("groupId", option);
        setSelectedGroupLabel(option);
        setRoomState((prevDetails) => ({
            ...prevDetails,
            groupId: option,
        }));
    };

    const updateRoomState = (key, value) => {
        setRoomState((prevState) => ({
            ...prevState,
            [key]: value,
        }));
    };

    const isFieldChanged = (field) => {
        if (!initialRoomState) return false;
        return JSON.stringify(roomState[field]) !== JSON.stringify(initialRoomState[field]);
    };

    const handleCheckmarkClick = async (label) => {
        const updateBody = {};

        if (label === "name") {
            updateBody.name = roomState.name;
        }
        if (label === "description") {
            updateBody.description = roomState.description;
        }
        if (label === "isVisibleInNavMenu") {
            updateBody.isVisibleInNavMenu = roomState.isVisibleInNavMenu;
        }
        if (label === "roomType") {
            updateBody.roomType = roomState.roomType;
        }
        if (label === "groupId") {
            const group = userGroups?.find((g) => g.level === roomState.groupId);
            updateBody.groupId = group?.id;
        }
        if (label === "tags") {
            updateBody.tags = roomState.tags.map((tag) => tag.id);
        }
        if (label === "ownerId") {
            updateBody.ownerId = roomState.ownerId;
        }
        if (label === "clientTag") {
            updateBody.clientTag = roomState.clientTag;
        }

        if (label === "bannerImageFile") {
            setLoading(true);
            const formData = new FormData();
            formData.append("bannerImg", selectedBannerImage);
            const response = await updateRoomImages(roomId, formData, token);
            if (response.status === 200) {
                setIsSuccess(true);
                refetchRoomData();
                setLoading(false);
                setSelectedBannerImage(null);
            } else {
                setIsError(true);
                setLoading(false);
                setSelectedBannerImage(null);
            }
        }

        if (label === "roomDetailsImageFile") {
            setLoading(true);
            const formData = new FormData();
            formData.append("roomDetailsImg", selectedRoomDetailsImage);
            const response = await updateRoomImages(roomId, formData, token);
            if (response.status === 200) {
                setIsSuccess(true);
                refetchRoomData();
                setLoading(false);
                setSelectedRoomDetailsImage(null);
            } else {
                setIsError(true);
                setLoading(false);
                setSelectedRoomDetailsImage(null);
            }
        }

        if (label === "roomOwnerImageFile") {
            setLoading(true);
            const formData = new FormData();
            formData.append("roomOwnerImg", selectedRoomOwnerImage);
            const response = await updateRoomImages(roomId, formData, token);
            if (response.status === 200) {
                setIsSuccess(true);
                refetchRoomData();
                setLoading(false);
                setSelectedRoomOwnerImage(null);
            } else {
                setIsError(true);
                setLoading(false);
                setSelectedRoomOwnerImage(null);
            }
        }

        if (Object.keys(updateBody).length !== 0) {
            const response = await updateRoom(roomId, updateBody);
            console.log("Response from updateRoom:", response);
            if (response.status === 200) {
                setInitialRoomState((prev) => ({
                    ...prev,
                    [label]: roomState[label],
                }));
                setIsSuccess(true);
                setSuccessMessage(response.data.message || "Room updated successfully");
                refetchRoomData();
            } else {
                setIsError(true);
                updateRoomState(label, initialRoomState[label]);
            }
        }
    };

    const handleBannerImageChange = (file) => {
        setSelectedBannerImage(file);
        updateRoomState("bannerImageFile", file);
    };

    const handleRoomDetailsImageChange = (file) => {
        setSelectedRoomDetailsImage(file);
        updateRoomState("roomDetailsImageFile", file);
    };

    const handleRoomOwnerImageChange = (file) => {
        setSelectedRoomOwnerImage(file);
        updateRoomState("roomOwnerImageFile", file);
    };

    // Room Settings

    const openJsonEditor = (fieldName, label, value) => {
        setCurrentField(fieldName);
        setCurrentFieldLabel(label);
        setJsonEditorValue(JSON.stringify(value, null, 2));
        setIsJsonEditorOpen(true);
    };

    const handleJsonSave = async (e, field) => {
        const respUpdateSettings = await updateRoomSettingsById(roomId, {
            [field]: e,
        });
        if (respUpdateSettings.status === 200) {
            setTooglesErr({ ...tooglesErr, [field]: "" });
            setErrorMessage(false);
            setSuccessMessage(true);
            setIsSuccess(true);
            setIsError(false);
        } else {
            setErrorMessage(true);
            setSuccessMessage(false);
            setIsSuccess(false);
            setIsError(true);
        }
        refetchRoomSettingsData();
    };

    const handleUpdateSettingsToogles = async (e, field) => {
        setTooglesLdr({ ...tooglesLdr, [field]: true });
        let respUpdateSettings = "";
        if (field !== "privacy") {
            respUpdateSettings = await updateRoomSettingsById(roomId, {
                [field]: e,
            });
        }
        if (field === "privacy") {
            respUpdateSettings = await updateRoomSettingsById(roomId, {
                [field]: e ? "public" : "private",
            });
        }
        if (respUpdateSettings.status === 200) {
            setTooglesErr({ ...tooglesErr, [field]: "" });
            setErrorMessage(false);
            setSuccessMessage(true);
            setTooglesSucs({
                ...tooglesSucs,
                [field]: `Success`,
            });
            setIsSuccess(true);
            setIsError(false);
            setTooglesLdr({ ...tooglesLdr, [field]: false });
            refetchRoomSettingsData();
        } else {
            setErrorMessage(true);
            setSuccessMessage(false);
            setTooglesErr({
                ...tooglesErr,
                [field]: `Failed`,
            });
            setIsSuccess(false);
            setIsError(true);
            setTooglesSucs({ ...tooglesSucs, [field]: "" });
            setTooglesLdr({ ...tooglesLdr, [field]: false });
        }
    };

    const handleContentClick = (e, field) => {
        if (field === "broadcastId") {
            setBroadcastIdVal(e.target.value);
            if (e.target.value === roomSettingsData.broadcastId) {
                setShowUpdateButtonBroad(false);
            } else {
                setShowUpdateButtonBroad(true);
            }
        }
        if (field === "spotifyTrack") {
            setSpotifyTrackVal(e.target.value);
            if (e.target.value === roomSettingsData.spotifyTrack) {
                setShowUpdateButtonSpotify(false);
            } else {
                setShowUpdateButtonSpotify(true);
            }
        }
    };

    const handleCloseClick = (field, value) => {
        if (field === "broadcastId") {
            setBroadcastIdVal(value);
        }
        if (field === "spotifyTrack") {
            setSpotifyTrackVal(value);
        }

        if (field === "keybindsPreset") {
            setPresetKeybinds(value);
        }
        setShowUpdateButtonBroad(false);
        setShowUpdateButtonSpotify(false);
        setShowUpdateKeybind(false);
    };

    const handleCheckmarkClickSettings = async (field, value) => {
        setTooglesLdr({ ...tooglesLdr, [field]: true });
        let respUpdateSettings = "";

        if (field === "spotifyTrack") {
            respUpdateSettings = await updateRoomSettingsById(roomId, {
                [field]: value,
            });
        }
        if (field === "broadcastId") {
            respUpdateSettings = await updateRoomSettingsById(roomId, {
                [field]: value,
            });
        }

        if (field === "keybindsPreset") {
            respUpdateSettings = await updateRoomSettingsById(roomId, {
                [field]: value,
            });
        }

        if (respUpdateSettings.status === 200) {
            setErrorMessage(false);
            setSuccessMessage(true);
            refetchRoomSettingsData();
            setShowUpdateButtonSpotify(false);
            setShowUpdateButtonBroad(false);
            setIsSuccess(true);
            setIsError(false);
        } else {
            setErrorMessage(true);
            setSuccessMessage(false);
            refetchRoomSettingsData();
            setShowUpdateButtonSpotify(false);
            setShowUpdateButtonBroad(false);
            setIsSuccess(false);
            setIsError(true);
        }
    };

    // for handling keybinds
    const usedKeys = Object.keys(presetKeybinds);
    const usedValues = Object.values(presetKeybinds);

    const handleAddKeybind = () => {
        if (newKey && newValue && !usedKeys.includes(newKey) && !usedValues.includes(newValue)) {
            setPresetKeybinds((prev) => {
                const updatedKeybinds = {
                    ...prev,
                    [newKey]: newValue,
                };
                if (JSON.stringify(updatedKeybinds) !== JSON.stringify(roomSettingsData.keybindsPreset)) {
                    setShowUpdateKeybind(true);
                }
                return updatedKeybinds;
            });
            setNewKey("");
            setNewValue("");
        }
    };

    const handleRemoveKeybind = (keyToRemove) => {
        setPresetKeybinds((prev) => {
            const { [keyToRemove]: _, ...remainingKeybinds } = prev;
            if (JSON.stringify(remainingKeybinds) !== JSON.stringify(roomSettingsData.keybindsPreset)) {
                setShowUpdateKeybind(true);
            } else {
                setShowUpdateKeybind(false);
            }
            return remainingKeybinds;
        });
    };

    const clearAllKeybinds = () => {
        setPresetKeybinds({});
        setNewKey("");
        setNewValue("");
        if (JSON.stringify(roomSettingsData.keybindsPreset) !== JSON.stringify({})) {
            setShowUpdateKeybind(true);
        } else {
            setShowUpdateKeybind(false);
        }
    };

    // Vanity Links

    const handleJsonSaveVanity = async (value, field) => {
        setFreeFormJson(JSON.stringify(value));
        const respUpdateVanity = await updateVanityLink(vanityId, {
            freeformJson: JSON.stringify(value),
        });
        if (respUpdateVanity.status === 200) {
            setIsSuccess(true);
            setLoading(false);
            setOriginalVanityData({
                ...originalVanityData,
                vanityLink: vanityLinkName,
                staticUrl,
                applicationId,
                freeformJson: JSON.parse(freeFormJson),
            });
        } else {
            setIsError(true);
            setLoading(false);
            setOriginalVanityData({
                ...originalVanityData,
                vanityLink: vanityLinkName,
                staticUrl,
                applicationId,
                freeformJson: JSON.parse(freeFormJson),
            });
        }
    };

    const isFieldChangedVanity = (field) => {
        if (field === "freeFormJson") {
            return JSON.stringify(freeFormJson) !== JSON.stringify(originalVanityData?.freeformJson);
        }
        if (field === "staticUrl") {
            return staticUrl !== originalVanityData?.staticUrl;
        }
        if (field === "applicationId") {
            return applicationId !== originalVanityData?.applicationId;
        }
        if (field === "vanityLinkName") {
            return vanityLinkName !== originalVanityData?.vanityLink;
        }
        if (field === "avatar") {
            const selectedSorted = [...selectedAvatars].sort();
            const originalSorted = [...(originalVanityData?.presetAvatarIds || [])].map((avatar) => avatar.id).sort();

            const isDifferent = JSON.stringify(selectedSorted) !== JSON.stringify(originalSorted);
            return isDifferent;
        }
        return false;
    };

    const handleCheckmarkClickVanity = async (label) => {
        setLoading(true);
        const data = {};

        if (label === "vanityLinkName") {
            data.vanityLink = vanityLinkName;
        }

        if (label === "freeFormJson") {
            data.freeformJson = JSON.parse(freeFormJson);
        }

        if (label === "staticUrl") {
            data.staticUrl = staticUrl;
        }

        if (label === "applicationId") {
            data.applicationId = applicationId;
        }

        if (label === "avatar") {
            data.presetAvatarIds = selectedAvatars;
        }

        const response = await updateVanityLink(vanityId, data);
        if (response.status === 200) {
            setIsSuccess(true);
            setLoading(false);
            setOriginalVanityData({
                ...originalVanityData,
                vanityLink: vanityLinkName,
                staticUrl,
                applicationId,
                freeformJson: JSON.parse(freeFormJson),
            });
        } else {
            setIsError(true);
            setLoading(false);
            setOriginalVanityData({
                ...originalVanityData,
                vanityLink: vanityLinkName,
                staticUrl,
                applicationId,
                freeformJson: JSON.parse(freeFormJson),
            });
        }
    };

    const toggleAvatarSelection = (avatarId) => {
        if (selectedAvatars.includes(avatarId)) {
            setSelectedAvatars(selectedAvatars.filter((id) => id !== avatarId));
        } else {
            setSelectedAvatars([...selectedAvatars, avatarId]);
        }
    };

    const handleVanityDataToggles = (updatedValue, field) => {
        if (field === "selectedAvatars") {
            handleCheckmarkClickVanity("avatar");
        }
    };

    // VANITY LINK DATA

    const isFieldChangedVanityData = (field) => {
        if (field === "clientName") {
            return clientName !== originalLinksData?.clientName;
        }
        if (field === "ssoMetadataJson") {
            return JSON.stringify(ssoMetadataJson) !== JSON.stringify(originalLinksData?.ssoMetadata);
        }
        if (field === "freeFormJsonLinkData") {
            return JSON.stringify(freeFormJsonLinkData) !== JSON.stringify(originalLinksData?.freeformJson);
        }
        if (field === "sso") {
            return sso !== originalLinksData?.sso;
        }
        if (field === "broadcast") {
            return broadcast !== originalLinksData?.broadcast;
        }
        if (field === "ambientTrackId") {
            return ambientTrackId !== originalLinksData?.ambientTrackId;
        }
        if (field === "guestOnlyMode") {
            return guestOnlyMode !== originalLinksData?.guestOnlyMode;
        }
        if (field === "marketingOptIn") {
            return marketingOptIn !== originalLinksData?.marketingOptIn;
        }
        if (field === "emailLoginEnabled") {
            return emailLoginEnabled !== originalLinksData?.emailLoginEnabled;
        }
        if (field === "fbLoginEnabled") {
            return fbLoginEnabled !== originalLinksData?.fbLoginEnabled;
        }
        if (field === "googleLoginEnabled") {
            return googleLoginEnabled !== originalLinksData?.googleLoginEnabled;
        }
        if (field === "twiiterLoginEnabled") {
            return twiiterLoginEnabled !== originalLinksData?.twiiterLoginEnabled;
        }
        if (field === "spotifyLoginEnabled") {
            return spotifyLoginEnabled !== originalLinksData?.spotifyLoginEnabled;
        }
        if (field === "otherLoginEnabled") {
            return otherLoginEnabled !== originalLinksData?.otherLoginEnabled;
        }

        return false;
    };

    const handleCheckmarkClickVanityData = async (label) => {
        setLoading(true);
        const formData = new FormData();

        if (label === "backgroundImage" && selectedBGImg) {
            formData.append("bgImage", selectedBGImg);
        }

        if (label === "miscImage" && selectedMiscImg) {
            formData.append("miscImage", selectedMiscImg);
        }

        if (label === "clientImage" && selectedClientImg) {
            formData.append("otherLoginImg", selectedClientImg);
        }

        if (label === "clientLogoImage" && selectedClientLogoImg) {
            formData.append("logo", selectedClientLogoImg);
        }
        const response = await updateVanityLinkDataImages(vanityId, formData, token);
        if (response.status === 200) {
            setIsSuccess(true);
            setLoading(false);
        } else {
            setIsError(true);
            setLoading(false);
        }
        setLoading(false);
        vanityLinkDataRefetch();
    };

    const handleJsonSaveSSO = async (value) => {
        setSsoMetadataJson(JSON.stringify(value));
        const respUpdateVanity = await updateVanityLink(vanityId, {
            ssoMetadata: JSON.parse(value),
        });
        if (respUpdateVanity.status === 200) {
            setIsSuccess(true);
            setLoading(false);
        } else {
            setIsError(true);
            setLoading(false);
        }
    };

    const handleJsonSaveVanityData = async (e, field) => {
        const responseVanityLinkData = await updateVanityLinkData(vanityId, {
            [field]: e,
        });
        if (responseVanityLinkData.status === 200) {
            setIsSuccess(true);
            setLoading(false);
        } else {
            setIsError(true);
            setLoading(false);
        }
        vanityLinkDataRefetch();
    };

    const handleVanityDataToogles = async (e, field) => {
        const payload = {};
        if (field === "emailLoginEnabled") {
            payload.emailLogin = e;
        }
        if (field === "fbLoginEnabled") {
            payload.fbLogin = e;
        }
        if (field === "googleLoginEnabled") {
            payload.googleLogin = e;
        }
        if (field === "twiiterLoginEnabled") {
            payload.twitterLogin = e;
        }
        if (field === "spotifyLoginEnabled") {
            payload.spotifyLogin = e;
        }
        if (field === "otherLoginEnabled") {
            payload.otherLogin = e;
        }
        if (field === "sso") {
            payload.sso = e;
        }
        if (field === "broadcast") {
            payload.broadcast = e;
        }
        if (field === "guestOnlyMode") {
            payload.guestOnlyMode = e;
        }
        if (field === "marketingOptIn") {
            payload.marketingOptIn = e;
        }
        if (field === "clientName") {
            payload.clientName = clientName;
        }

        const response = await updateVanityLinkData(vanityId, payload);
        if (response.status === 200) {
            setIsSuccess(true);
            setLoading(false);
        } else {
            setIsError(true);
            setLoading(false);
        }
        vanityLinkDataRefetch();
    };

    return (
        <>
            <Banner
                width={"100%"}
                zIndex="1000"
                message={isSuccess ? successMessage : "Successfully updated"}
                type={"SUCCESS"}
                openBanner={!!isSuccess}
                setOpenBanner={setIsSuccess}
                topDisplay
                showCloseButton
                gameScreen={false}
                top={"0px"}
                left={"0"}
            />
            <Banner
                width={"100%"}
                zIndex="1000"
                message={bannerMessage}
                type={"ERROR"}
                openBanner={!!isError}
                setOpenBanner={setIsError}
                topDisplay
                showCloseButton
                gameScreen={false}
                top={"0px"}
                left={"0"}
            />
            <ModalContent>
                <Typography variant="h2PurpleHeading" margin={`0 0 1rem 0`}>
                    Update Data
                </Typography>
                <NavContainer>
                    {tabs?.map((tab) => (
                        <Tab key={tab} active={activeTab === tab} onClick={() => setActiveTab(tab)}>
                            {tab}
                        </Tab>
                    ))}
                </NavContainer>

                {activeTab === "ROOM" && (
                    <>
                        <Table>
                            <TableRow>
                                <TableColumn>
                                    <Label>Room ID</Label>
                                    <InputBox type="text" disabled value={roomId} />
                                </TableColumn>
                            </TableRow>

                            {/* Room Name */}
                            <TableRow>
                                <TableColumn>
                                    <Label>Room Name</Label>
                                    <InputBox
                                        type="text"
                                        id="roomName"
                                        placeholder="Enter Room Name"
                                        value={roomState.name}
                                        onChange={(e) => updateRoomState("name", e.target.value)}
                                    />
                                    {isFieldChanged("name") && (
                                        <Row>
                                            <StyledCheckmark onClick={() => handleCheckmarkClick("name")} />
                                            <StyledCloseIcon
                                                onClick={() => {
                                                    updateRoomState("name", initialRoomState.name);
                                                }}
                                            />
                                        </Row>
                                    )}
                                </TableColumn>
                            </TableRow>

                            {/* Description */}
                            <TableRow>
                                <TableColumn>
                                    <Label>Description</Label>
                                    <InputBox
                                        type="text"
                                        id="description"
                                        placeholder="Enter Description"
                                        value={roomState.description}
                                        onChange={(e) => updateRoomState("description", e.target.value)}
                                    />
                                    {isFieldChanged("description") && (
                                        <Row>
                                            <StyledCheckmark onClick={() => handleCheckmarkClick("description")} />
                                            <StyledCloseIcon
                                                onClick={() => {
                                                    updateRoomState("description", initialRoomState.description);
                                                }}
                                            />
                                        </Row>
                                    )}
                                </TableColumn>
                            </TableRow>

                            {/* Nav Menu Toggle */}
                            <TableRow style={{ padding: "5px" }}>
                                <Label style={{ marginRight: "15px" }}>Visible on Nav Menu</Label>
                                <ToggleSwitch
                                    value={roomState.isVisibleInNavMenu}
                                    onChange={(value) => {
                                        updateRoomState("isVisibleInNavMenu", value);
                                    }}
                                />
                                {isFieldChanged("isVisibleInNavMenu") && (
                                    <Row>
                                        <StyledCheckmark onClick={() => handleCheckmarkClick("isVisibleInNavMenu")} />

                                        <StyledCloseIcon
                                            onClick={() => {
                                                updateRoomState(
                                                    "isVisibleInNavMenu",
                                                    initialRoomState.isVisibleInNavMenu
                                                );
                                            }}
                                        />
                                    </Row>
                                )}
                            </TableRow>

                            {/* Room Type */}
                            <TableRow>
                                <TableColumn>
                                    <Dropdown
                                        key={"roomTypeInput"}
                                        label="Room Type"
                                        items={roomPrefabs?.map((item) => ({
                                            value: item.roomType,
                                            label: item.roomType,
                                        }))}
                                        selectedValue={roomState.roomType}
                                        setSelectedValue={setRoomType}
                                        placeholder="Select Room Type"
                                    />
                                    <Row>
                                        <TextP>
                                            Can't find the room type you're looking for?
                                            <Button
                                                variant={"NavigationButton"}
                                                fontSize={"12px"}
                                                margin={"5px 0 0 10px"}
                                                label={"Create New Room Type"}
                                                onClick={handleAddRoomTypeClick}
                                            />
                                        </TextP>
                                    </Row>
                                    <Row>
                                        <TextP>
                                            Need to update the RoomPrefab UUID from Unity for this room type?
                                            <Button
                                                variant={"NavigationButton"}
                                                fontSize={"12px"}
                                                margin={"5px 0 0 10px"}
                                                label={"Update"}
                                                onClick={handleRoomPrefabClick}
                                            />
                                        </TextP>
                                    </Row>
                                    {isFieldChanged("roomType") && (
                                        <Row>
                                            <StyledCheckmark onClick={() => handleCheckmarkClick("roomType")} />

                                            <StyledCloseIcon
                                                onClick={() => {
                                                    updateRoomState("roomType", initialRoomState.roomType);
                                                }}
                                            />
                                        </Row>
                                    )}
                                </TableColumn>
                            </TableRow>

                            {/* User Group */}
                            <TableRow>
                                <TableColumn>
                                    <Dropdown
                                        label="User Group"
                                        items={userGroups?.map((item) => ({
                                            ...item,
                                            id: item.id,
                                            value: item.level,
                                        }))}
                                        selectedValue={selectedGroupLabel}
                                        setSelectedValue={setRoomGroupId}
                                        placeholder="Select User Group"
                                    />
                                    {isFieldChanged("groupId") && (
                                        <Row>
                                            <StyledCheckmark onClick={() => handleCheckmarkClick("groupId")} />

                                            <StyledCloseIcon
                                                onClick={() => updateRoomState("groupId", initialRoomState.groupId)}
                                            />
                                        </Row>
                                    )}
                                </TableColumn>
                            </TableRow>

                            {/* Room Tags */}
                            <TableRow>
                                <TableColumn>
                                    <Dropdown
                                        label="Tags"
                                        items={roomTags?.map((item) => ({
                                            id: item.id,
                                            value: item.label,
                                        }))}
                                        selectedValue={selectedRoomTags}
                                        setSelectedValue={handleRoomTagsClick}
                                        placeholder="Select Room Tags"
                                        tags={roomState.tags}
                                        removeTags={handleRemoveTag}
                                    />
                                    {isFieldChanged("tags") && (
                                        <Row>
                                            <StyledCheckmark onClick={() => handleCheckmarkClick("tags")} />

                                            <StyledCloseIcon
                                                onClick={() => {
                                                    updateRoomState("tags", initialRoomState.tags);
                                                    setSelectedRoomTags(initialRoomState.tags);
                                                }}
                                            />
                                        </Row>
                                    )}
                                </TableColumn>
                            </TableRow>

                            <TableRow>
                                <TableColumn>
                                    <Label>Client Tag</Label>
                                    <InputBox
                                        type="text"
                                        id="clientTag"
                                        placeholder="Enter Client Tag"
                                        value={roomState.clientTag}
                                        onChange={(e) => updateRoomState("clientTag", e.target.value)}
                                    />
                                    {isFieldChanged("clientTag") && (
                                        <Row>
                                            <StyledCheckmark onClick={() => handleCheckmarkClick("clientTag")} />
                                            <StyledCloseIcon
                                                onClick={() => {
                                                    updateRoomState("clientTag", initialRoomState.clientTag);
                                                }}
                                            />
                                        </Row>
                                    )}
                                </TableColumn>
                            </TableRow>

                            {/* Owner */}
                            <TableRow>
                                <TableColumn>
                                    <UserSearchDropdown
                                        label="Search Email to update Owner"
                                        onSelection={handleUserClickOwner}
                                        selectedUser={roomState.ownerId}
                                        value={roomState.ownerId}
                                    />
                                    {isFieldChanged("ownerId") && (
                                        <Row>
                                            <StyledCheckmark onClick={() => handleCheckmarkClick("ownerId")} />

                                            <StyledCloseIcon
                                                onClick={() => {
                                                    updateRoomState("ownerId", initialRoomState.ownerId);
                                                    updateRoomState("ownerName", initialRoomState.ownerName);
                                                }}
                                            />
                                        </Row>
                                    )}
                                </TableColumn>
                            </TableRow>

                            {roomState.ownerId && (
                                <>
                                    <TableRow>
                                        <TableColumn>
                                            <Label>Owner Id</Label>
                                            <InputBox
                                                type="text"
                                                disabled
                                                id="ownerId"
                                                value={roomState.ownerId}
                                                readOnly
                                            />
                                        </TableColumn>
                                    </TableRow>
                                </>
                            )}
                            {roomState.ownerName && (
                                <TableRow>
                                    <TableColumn>
                                        <Label>Owner Name</Label>
                                        <InputBox
                                            type="text"
                                            disabled
                                            id="ownerName"
                                            value={roomState.ownerName}
                                            readOnly
                                        />
                                    </TableColumn>
                                </TableRow>
                            )}

                            <TableRow>
                                <TableColumn>
                                    <UploadFile
                                        label="Replace Banner Image"
                                        accept={["image/png", "image/jpeg", "image/jpg"]}
                                        selectedFile={selectedBannerImage}
                                        setSelectedFile={handleBannerImageChange}
                                        source="withoutCallingFileUploadAPI"
                                    />
                                    {selectedBannerImage && (
                                        <Row>
                                            <StyledCheckmark onClick={() => handleCheckmarkClick("bannerImageFile")} />

                                            <StyledCloseIcon
                                                onClick={() => {
                                                    updateRoomState(
                                                        "bannerImageFile",
                                                        initialRoomState.bannerImageFile
                                                    );
                                                    setSelectedBannerImage(null);
                                                }}
                                            />
                                        </Row>
                                    )}
                                </TableColumn>
                                <TableColumn>
                                    {roomData?.bannerImageKey && bannerImageUrl && (
                                        <img src={bannerImageUrl?.data} alt="Banner" style={{ width: "50%" }} />
                                    )}
                                </TableColumn>
                            </TableRow>

                            <TableRow>
                                <TableColumn>
                                    <UploadFile
                                        label="Replace Details Image"
                                        accept={["image/png", "image/jpeg", "image/jpg"]}
                                        selectedFile={selectedRoomDetailsImage}
                                        setSelectedFile={handleRoomDetailsImageChange}
                                        source="withoutCallingFileUploadAPI"
                                    />
                                    {selectedRoomDetailsImage && (
                                        <Row>
                                            <StyledCheckmark
                                                onClick={() => handleCheckmarkClick("roomDetailsImageFile")}
                                            />

                                            <StyledCloseIcon
                                                onClick={() => {
                                                    updateRoomState(
                                                        "roomDetailsImageFile",
                                                        initialRoomState.roomDetailsImageFile
                                                    );
                                                    setSelectedRoomDetailsImage(null);
                                                }}
                                            />
                                        </Row>
                                    )}
                                </TableColumn>
                                <TableColumn>
                                    {roomData?.roomDetailsImageId && roomDetailsImageUrl && (
                                        <img
                                            src={roomDetailsImageUrl?.data}
                                            alt="Room Details"
                                            style={{ width: "50%" }}
                                        />
                                    )}
                                </TableColumn>
                            </TableRow>

                            <TableRow>
                                <TableColumn>
                                    <UploadFile
                                        label="Replace Owner Image"
                                        accept={["image/png", "image/jpeg", "image/jpg"]}
                                        selectedFile={selectedRoomOwnerImage}
                                        setSelectedFile={handleRoomOwnerImageChange}
                                        source="withoutCallingFileUploadAPI"
                                    />
                                    {selectedRoomOwnerImage && (
                                        <Row>
                                            <StyledCheckmark
                                                onClick={() => handleCheckmarkClick("roomOwnerImageFile")}
                                            />
                                            {loading && <LoadingIcon />}
                                            <StyledCloseIcon
                                                onClick={() => {
                                                    setSelectedRoomOwnerImage(null);
                                                    updateRoomState(
                                                        "roomOwnerImageFile",
                                                        initialRoomState.roomOwnerImageFile
                                                    );
                                                }}
                                            />
                                        </Row>
                                    )}
                                </TableColumn>
                                <TableColumn>
                                    {roomData?.roomOwnerImageId && roomOwnerImageUrl && (
                                        <img src={roomOwnerImageUrl?.data} alt="Room Owner" style={{ width: "50%" }} />
                                    )}
                                </TableColumn>
                            </TableRow>
                        </Table>
                    </>
                )}

                {activeTab === "ROOM SETTINGS" && (
                    <>
                        <Table>
                            <TableRow>
                                <TableColumn>
                                    <Label>Room ID</Label>
                                    <InputBox type="text" disabled value={roomId} />
                                </TableColumn>
                            </TableRow>
                            <TableRow>
                                <TableColumn>
                                    <Label>Room Settings ID</Label>
                                    <InputBox type="text" disabled value={roomSettingsData?.roomSettingsId} />
                                </TableColumn>
                            </TableRow>
                            <TableRow>
                                <TableColumn>
                                    <Label>Enable Voice Chat</Label>
                                    <ToggleSwitch
                                        value={voiceChatEnabled}
                                        onChange={(e) => handleUpdateSettingsToogles(e, "voiceChatEnabled")}
                                    />
                                    {tooglesLdr.voiceChatEnabled && (
                                        <LoadingDiv>
                                            <LoadingIcon />
                                        </LoadingDiv>
                                    )}
                                    {tooglesErr.voiceChatEnabled && (
                                        <MessageDesc type="error">{tooglesErr.voiceChatEnabled}</MessageDesc>
                                    )}
                                    {tooglesSucs.voiceChatEnabled && (
                                        <MessageDesc type="success">{tooglesSucs.voiceChatEnabled}</MessageDesc>
                                    )}
                                </TableColumn>
                                <TableColumn>
                                    <Label>Privacy: Is Room Public?</Label>
                                    <ToggleSwitch
                                        value={privacy === "public"}
                                        onChange={(e) => handleUpdateSettingsToogles(e, "privacy")}
                                    />
                                    {tooglesLdr.privacy && (
                                        <LoadingDiv>
                                            <LoadingIcon />
                                        </LoadingDiv>
                                    )}
                                    {tooglesErr.privacy && <MessageDesc type="error">{tooglesErr.privacy}</MessageDesc>}
                                    {tooglesSucs.privacy && (
                                        <MessageDesc type="success">{tooglesSucs.privacy}</MessageDesc>
                                    )}
                                </TableColumn>
                                <TableColumn>
                                    <Label>Show Leaderboards</Label>
                                    <ToggleSwitch
                                        value={leaderboardsEnabled}
                                        onChange={(e) => handleUpdateSettingsToogles(e, "leaderboardsEnabled")}
                                    />
                                    {tooglesLdr.leaderboardsEnabled && (
                                        <LoadingDiv>
                                            <LoadingIcon />
                                        </LoadingDiv>
                                    )}
                                    {tooglesErr.leaderboardsEnabled && (
                                        <MessageDesc type="error">{tooglesErr.leaderboardsEnabled}</MessageDesc>
                                    )}
                                    {tooglesSucs.leaderboardsEnabled && (
                                        <MessageDesc type="success">{tooglesSucs.leaderboardsEnabled}</MessageDesc>
                                    )}
                                </TableColumn>
                            </TableRow>
                            <TableRow>
                                <TableColumn>
                                    <Label>Spotify Integration</Label>
                                    <ToggleSwitch
                                        value={spotifyEnabled}
                                        onChange={(e) => handleUpdateSettingsToogles(e, "spotifyEnabled")}
                                    />
                                    {tooglesLdr.spotifyEnabled && (
                                        <LoadingDiv>
                                            <LoadingIcon />
                                        </LoadingDiv>
                                    )}
                                    {tooglesErr.spotifyEnabled && (
                                        <MessageDesc type="error">{tooglesErr.spotifyEnabled}</MessageDesc>
                                    )}
                                    {tooglesSucs.spotifyEnabled && (
                                        <MessageDesc type="success">{tooglesSucs.spotifyEnabled}</MessageDesc>
                                    )}
                                </TableColumn>
                                <TableColumn>
                                    <Label>Enable E-commerce Features</Label>
                                    <ToggleSwitch
                                        value={ecommerceEnabled}
                                        onChange={(e) => handleUpdateSettingsToogles(e, "ecommerceEnabled")}
                                    />
                                    {tooglesLdr.ecommerceEnabled && (
                                        <LoadingDiv>
                                            <LoadingIcon />
                                        </LoadingDiv>
                                    )}
                                    {tooglesErr.ecommerceEnabled && (
                                        <MessageDesc type="error">{tooglesErr.ecommerceEnabled}</MessageDesc>
                                    )}
                                    {tooglesSucs.ecommerceEnabled && (
                                        <MessageDesc type="success">{tooglesSucs.ecommerceEnabled}</MessageDesc>
                                    )}
                                </TableColumn>
                                <TableColumn>
                                    <Label>Show Settings Menu</Label>
                                    <ToggleSwitch
                                        value={settingsMenuEnabled}
                                        onChange={(e) => handleUpdateSettingsToogles(e, "settingsMenuEnabled")}
                                    />
                                    {tooglesLdr.settingsMenuEnabled && (
                                        <LoadingDiv>
                                            <LoadingIcon />
                                        </LoadingDiv>
                                    )}
                                    {tooglesErr.settingsMenuEnabled && (
                                        <MessageDesc type="error">{tooglesErr.settingsMenuEnabled}</MessageDesc>
                                    )}
                                    {tooglesSucs.settingsMenuEnabled && (
                                        <MessageDesc type="success">{tooglesSucs.settingsMenuEnabled}</MessageDesc>
                                    )}
                                </TableColumn>
                            </TableRow>
                            <TableRow>
                                <TableColumn>
                                    <Label>Can Return to Navigation Menu?</Label>
                                    <ToggleSwitch
                                        value={canReturnToNavMenuEnabled}
                                        onChange={(e) => handleUpdateSettingsToogles(e, "canReturnToNavMenuEnabled")}
                                    />
                                    {tooglesLdr.canReturnToNavMenuEnabled && (
                                        <LoadingDiv>
                                            <LoadingIcon />
                                        </LoadingDiv>
                                    )}
                                    {tooglesErr.canReturnToNavMenuEnabled && (
                                        <MessageDesc type="error">{tooglesErr.canReturnToNavMenuEnabled}</MessageDesc>
                                    )}
                                    {tooglesSucs.canReturnToNavMenuEnabled && (
                                        <MessageDesc type="success">
                                            {tooglesSucs.canReturnToNavMenuEnabled}
                                        </MessageDesc>
                                    )}
                                </TableColumn>
                                <TableColumn>
                                    <Label>Text Chat Enabled</Label>
                                    <ToggleSwitch
                                        value={textChatEnabled}
                                        onChange={(e) => handleUpdateSettingsToogles(e, "textChatEnabled")}
                                    />
                                    {tooglesLdr.textChatEnabled && (
                                        <LoadingDiv>
                                            <LoadingIcon />
                                        </LoadingDiv>
                                    )}
                                    {tooglesErr.textChatEnabled && (
                                        <MessageDesc type="error">{tooglesErr.textChatEnabled}</MessageDesc>
                                    )}
                                    {tooglesSucs.textChatEnabled && (
                                        <MessageDesc type="success">{tooglesSucs.textChatEnabled}</MessageDesc>
                                    )}
                                </TableColumn>
                                <TableColumn>
                                    <Label>Show Emote Wheel</Label>
                                    <ToggleSwitch
                                        value={showEmoteWheel}
                                        onChange={(e) => handleUpdateSettingsToogles(e, "showEmoteWheel")}
                                    />
                                    {tooglesLdr.showEmoteWheel && (
                                        <LoadingDiv>
                                            <LoadingIcon />
                                        </LoadingDiv>
                                    )}
                                    {tooglesErr.showEmoteWheel && (
                                        <MessageDesc type="error">{tooglesErr.showEmoteWheel}</MessageDesc>
                                    )}
                                    {tooglesSucs.showEmoteWheel && (
                                        <MessageDesc type="success">{tooglesSucs.showEmoteWheel}</MessageDesc>
                                    )}
                                </TableColumn>
                                <TableColumn>
                                    <Label>Show Friends</Label>
                                    <ToggleSwitch
                                        value={showFriends}
                                        onChange={(e) => handleUpdateSettingsToogles(e, "showFriends")}
                                    />
                                    {tooglesLdr.showFriends && (
                                        <LoadingDiv>
                                            <LoadingIcon />
                                        </LoadingDiv>
                                    )}
                                    {tooglesErr.showFriends && (
                                        <MessageDesc type="error">{tooglesErr.showFriends}</MessageDesc>
                                    )}
                                    {tooglesSucs.showFriends && (
                                        <MessageDesc type="success">{tooglesSucs.showFriends}</MessageDesc>
                                    )}
                                </TableColumn>
                            </TableRow>
                            <TableRow>
                                <TableColumn>
                                    <Label>Chat Channel ID</Label>
                                    <InputBox
                                        type="text"
                                        name="chatChannelId"
                                        disabled
                                        value={roomSettingsData?.chatChannelId}
                                    />
                                </TableColumn>
                            </TableRow>
                            <TableRow>
                                <TableColumn>
                                    <Label>Spotify Track</Label>
                                    <InputBox
                                        type="text"
                                        name="spotifyTrack"
                                        value={spotifyTrackVal}
                                        onChange={(e) => handleContentClick(e, "spotifyTrack")}
                                    />
                                    {showUpdateButtonSpotify && (
                                        <>
                                            <StyledCheckmark
                                                onClick={() =>
                                                    handleCheckmarkClickSettings("spotifyTrack", spotifyTrackVal)
                                                }
                                            />
                                            <StyledCloseIcon
                                                onClick={() =>
                                                    spotifyTrackVal &&
                                                    handleCloseClick("spotifyTrack", roomSettingsData.spotifyTrack)
                                                }
                                            />
                                        </>
                                    )}
                                </TableColumn>
                            </TableRow>

                            <TableRow>
                                <TableColumn>
                                    <Label>Broadcast ID</Label>
                                    <InputBox
                                        type="text"
                                        name="broadcastId"
                                        value={broadcastIdVal}
                                        onChange={(e) => handleContentClick(e, "broadcastId")}
                                    />
                                    {showUpdateButtonBroad && (
                                        <>
                                            <StyledCheckmark
                                                onClick={() =>
                                                    handleCheckmarkClickSettings("broadcastId", broadcastIdVal)
                                                }
                                            />
                                            <StyledCloseIcon
                                                onClick={() =>
                                                    broadcastIdVal &&
                                                    handleCloseClick("broadcastId", roomSettingsData.broadcastId)
                                                }
                                            />
                                        </>
                                    )}
                                </TableColumn>
                            </TableRow>

                            <TableRow>
                                <TableColumn>
                                    {[
                                        {
                                            name: "passwords",
                                            label: "Passwords",
                                        },
                                        {
                                            name: "products",
                                            label: "Products",
                                        },
                                        {
                                            name: "videoPayload",
                                            label: "Video Payload",
                                        },
                                    ].map(({ name, label }) => (
                                        <Column errorMessage key={name}>
                                            <Label>{label}</Label>
                                            <InputBox
                                                type="text"
                                                name={name}
                                                value={JSON.stringify(roomSettingsData?.[name] || {})}
                                                onClick={() => openJsonEditor(name, label, roomSettingsData?.[name])}
                                            />
                                        </Column>
                                    ))}
                                </TableColumn>
                            </TableRow>

                            <TableRow>
                                <TableColumn>
                                    {[
                                        {
                                            name: "linkoutPayload",
                                            label: "External Links",
                                        },
                                        {
                                            name: "panelPromptText",
                                            label: "Panel Prompt Instructions",
                                        },
                                        {
                                            name: "coordinates",
                                            label: "Location Coordinates",
                                        },
                                        {
                                            name: "dynamicLinkouts",
                                            label: "Dynamic Linkouts",
                                        },
                                    ].map(({ name, label }) => (
                                        <Column key={name}>
                                            <Label>{label}</Label>
                                            <InputBox
                                                type="text"
                                                name={name}
                                                value={JSON.stringify(roomSettingsData?.[name] || {})}
                                                onClick={() => openJsonEditor(name, label, roomSettingsData?.[name])}
                                            />
                                        </Column>
                                    ))}
                                </TableColumn>
                            </TableRow>

                            <TableRow>
                                <TableColumn>
                                    <Label>Preset Key binds</Label>
                                    <KeybindContainer>
                                        <SelectBox value={newKey} onChange={(e) => setNewKey(e.target.value)}>
                                            <option value="">Select Key</option>
                                            {keyOptions
                                                .filter((key) => !usedKeys.includes(key))
                                                .map((key) => (
                                                    <option key={key} value={key}>
                                                        {key}
                                                    </option>
                                                ))}
                                        </SelectBox>
                                        <SelectBox
                                            value={newValue}
                                            onChange={(e) => {
                                                setNewValue(e.target.value);
                                            }}
                                        >
                                            <option value="">Select Action</option>
                                            {valueOptions
                                                .filter((val) => !usedValues.includes(val))
                                                .map((val) => (
                                                    <option key={val} value={val}>
                                                        {val}
                                                    </option>
                                                ))}
                                        </SelectBox>
                                        <Button
                                            type="button"
                                            variant={"SmallButton"}
                                            label={"+"}
                                            onClick={handleAddKeybind}
                                            disabled={
                                                !newKey ||
                                                !newValue ||
                                                usedKeys.includes(newKey) ||
                                                Object.keys(presetKeybinds).length >= 8
                                            }
                                        />
                                    </KeybindContainer>
                                    <KeybindList>
                                        {Object.keys(presetKeybinds).length >= 8 && (
                                            <Typography
                                                variant="pWhite"
                                                margin={"0"}
                                                fontSize={"18px"}
                                                color={`${setColor.redLightWarning}`}
                                                align={"left"}
                                                letterSpacing={"0px"}
                                            >
                                                You can only add up to 8 keybinds.
                                            </Typography>
                                        )}
                                        {Object.entries(presetKeybinds).map(([key, val]) => (
                                            <KeybindItem key={key}>
                                                {key} → {val}
                                                <Button
                                                    variant={"SmallButton"}
                                                    margin={"0 0 0 10px"}
                                                    label="-"
                                                    onClick={() => handleRemoveKeybind(key)}
                                                />
                                            </KeybindItem>
                                        ))}
                                    </KeybindList>
                                    <Button
                                        type="button"
                                        variant={"SmallButton"}
                                        margin={"10px 0 0 0"}
                                        label="Clear All"
                                        onClick={() => clearAllKeybinds()}
                                    />
                                    {showUpdateKeybind && (
                                        <>
                                            <StyledCheckmark
                                                onClick={() =>
                                                    handleCheckmarkClickSettings("keybindsPreset", presetKeybinds)
                                                }
                                            />
                                            <StyledCloseIcon
                                                onClick={() =>
                                                    handleCloseClick("keybindsPreset", roomSettingsData.keybindsPreset)
                                                }
                                            />
                                        </>
                                    )}
                                </TableColumn>
                            </TableRow>
                        </Table>
                    </>
                )}

                {activeTab === "VANITY LINK" && (
                    <>
                        {avatarPresetsLoading && (
                            <>
                                <Table>
                                    <TableRow>
                                        <LoadingIcon />
                                    </TableRow>
                                </Table>
                            </>
                        )}
                        {!avatarPresetsLoading && (
                            <>
                                <Table>
                                    <TableRow>
                                        <TableColumn>
                                            <Label>Room ID</Label>
                                            <InputBox type="text" id="vanityId" disabled value={roomId} />
                                        </TableColumn>
                                    </TableRow>
                                    <TableRow>
                                        <TableColumn>
                                            <Label>Vanity ID</Label>
                                            <InputBox type="text" id="vanityId" disabled value={vanityId} />
                                        </TableColumn>
                                    </TableRow>
                                    <TableRow>
                                        <TableColumn>
                                            <Label>Vanity Link Name*</Label>
                                            <InputBox
                                                type="text"
                                                id="vanityLinkName"
                                                placeholder="Enter vanity Link Name"
                                                value={vanityLinkName}
                                                onChange={(e) => setVanityLinkName(e.target.value)}
                                            />
                                            {isFieldChangedVanity("vanityLinkName") && (
                                                <Row>
                                                    <StyledCheckmark
                                                        onClick={() => handleCheckmarkClickVanity("vanityLinkName")}
                                                    />
                                                    <StyledCloseIcon
                                                        onClick={() => {
                                                            setVanityLinkName(data?.vanityLink || "");
                                                        }}
                                                    />
                                                </Row>
                                            )}
                                        </TableColumn>
                                    </TableRow>

                                    <TableRow>
                                        <TableColumn>
                                            <Label>Static URL</Label>
                                            <InputBox
                                                type="text"
                                                id="staticUrl"
                                                placeholder="Enter Static URL"
                                                value={staticUrl}
                                                onChange={(e) => setStaticUrl(e.target.value)}
                                            />
                                            {isFieldChangedVanity("staticUrl") && (
                                                <Row>
                                                    <StyledCheckmark
                                                        onClick={() => handleCheckmarkClickVanity("staticUrl")}
                                                    />
                                                    <StyledCloseIcon
                                                        onClick={() => {
                                                            setStaticUrl(data?.staticUrl || "");
                                                        }}
                                                    />
                                                </Row>
                                            )}
                                        </TableColumn>
                                    </TableRow>

                                    <TableRow>
                                        <TableColumn>
                                            <Label>Application ID</Label>
                                            <InputBox
                                                type="text"
                                                id="applicationId"
                                                placeholder="Enter Application ID"
                                                value={applicationId}
                                                onChange={(e) => setApplicationId(e.target.value)}
                                            />
                                            {isFieldChangedVanity("applicationId") && (
                                                <Row>
                                                    <StyledCheckmark
                                                        onClick={() => handleCheckmarkClickVanity("applicationId")}
                                                    />
                                                    <StyledCloseIcon
                                                        onClick={() => {
                                                            setApplicationId(data?.applicationId || "");
                                                        }}
                                                    />
                                                </Row>
                                            )}
                                        </TableColumn>
                                    </TableRow>

                                    <TableRow>
                                        <TableColumn>
                                            <Label>FreeForm Json</Label>
                                            <InputBox
                                                type="text"
                                                id="freeFormJson"
                                                placeholder="Enter FreeForm Json"
                                                value={freeFormJson}
                                                onClick={() => setIsJsonEditorOpenVanity(true)}
                                            />
                                        </TableColumn>
                                    </TableRow>
                                    <TableRow>
                                        <TableColumn>
                                            <AvatarGrid>
                                                {!avatarPresetsLoading && avatarPresets?.length > 0 && (
                                                    <>
                                                        {avatarPresets.map((item, index) => {
                                                            const isSelected = selectedAvatars.includes(item.id);
                                                            return (
                                                                <AvatarContainer
                                                                    key={index}
                                                                    onClick={() => toggleAvatarSelection(item.id)}
                                                                >
                                                                    <StyledImages
                                                                        src={item.fileUrl}
                                                                        alt="Avatar Preset"
                                                                        selected={isSelected}
                                                                    />
                                                                    {isSelected && (
                                                                        <CheckmarkAvatar>✔</CheckmarkAvatar>
                                                                    )}
                                                                </AvatarContainer>
                                                            );
                                                        })}
                                                    </>
                                                )}
                                            </AvatarGrid>
                                        </TableColumn>
                                    </TableRow>
                                    <TableRow>
                                        {isFieldChangedVanity("avatar") && (
                                            <Row>
                                                <StyledCheckmark
                                                    onClick={() =>
                                                        handleVanityDataToggles(selectedAvatars, "selectedAvatars")
                                                    }
                                                />
                                                <StyledCloseIcon
                                                    onClick={() =>
                                                        setSelectedAvatars(
                                                            data?.presetAvatarIds?.map((avatar) => avatar.id) ?? []
                                                        )
                                                    }
                                                />
                                            </Row>
                                        )}
                                    </TableRow>
                                </Table>
                            </>
                        )}
                    </>
                )}

                {activeTab === "VANITY LINK DATA" && (
                    <Table>
                        <TableRow>
                            <TableColumn>
                                <Label>Room ID</Label>
                                <InputBox type="text" id="vanityId" disabled value={roomId} />
                            </TableColumn>
                        </TableRow>
                        <TableRow>
                            <TableColumn>
                                <Label>Vanity ID</Label>
                                <InputBox type="text" id="vanityId" disabled value={vanityId} />
                            </TableColumn>
                        </TableRow>
                        <TableRow>
                            <TableColumn>
                                <Label>Client Name*</Label>
                                <InputBox
                                    type="text"
                                    id="clientName"
                                    placeholder="Enter Client Name"
                                    value={clientName}
                                    onChange={(e) => setClientName(e.target.value)}
                                />
                                {isFieldChangedVanityData("clientName") && (
                                    <Row>
                                        <StyledCheckmark
                                            onClick={() => handleVanityDataToogles(clientName, "clientName")}
                                        />
                                        <StyledCloseIcon
                                            onClick={() => {
                                                setOriginalLinksData({
                                                    ...originalLinksData,
                                                    clientName,
                                                });
                                                vanityLinkDataRefetch();
                                            }}
                                        />
                                    </Row>
                                )}
                            </TableColumn>
                        </TableRow>
                        <TableRow>
                            <TableColumn>
                                <Label>FreeForm Json</Label>
                                <InputBox
                                    type="text"
                                    id="freeFormJson"
                                    placeholder="Enter FreeForm Json"
                                    value={freeFormJsonLinkData}
                                    onClick={() => setIsJsonEditorOpenLinkData(true)}
                                />
                            </TableColumn>
                        </TableRow>

                        <TableRow>
                            <TableColumn>
                                <UploadFile
                                    label="Replace Vanity Background Image"
                                    accept={["image/png", "image/jpeg", "image/jpg"]}
                                    selectedFile={selectedBGImg}
                                    setSelectedFile={setSelectedBGImg}
                                    source="withoutCallingFileUploadAPI"
                                />
                                {selectedBGImg && (
                                    <Row>
                                        <StyledCheckmark
                                            onClick={() => handleCheckmarkClickVanityData("backgroundImage")}
                                        />

                                        <StyledCloseIcon
                                            onClick={() => {
                                                setSelectedBGImg(null);
                                                vanityLinkDataRefetch();
                                            }}
                                        />
                                    </Row>
                                )}
                            </TableColumn>
                            <TableColumn>{bGUrl && <img src={bGUrl} alt="BG" style={{ width: "50%" }} />}</TableColumn>
                        </TableRow>

                        <TableRow>
                            <TableColumn>
                                <UploadFile
                                    label="Replace Miscellaneous Image"
                                    accept={["image/png", "image/jpeg", "image/jpg"]}
                                    selectedFile={selectedMiscImg}
                                    setSelectedFile={setSelectedMiscImg}
                                    source="withoutCallingFileUploadAPI"
                                />
                                {selectedMiscImg && (
                                    <Row>
                                        <StyledCheckmark onClick={() => handleCheckmarkClickVanityData("miscImage")} />

                                        <StyledCloseIcon
                                            onClick={() => {
                                                setSelectedMiscImg(null);
                                            }}
                                        />
                                    </Row>
                                )}
                            </TableColumn>
                            <TableColumn>
                                {miscImageUrl && <img src={miscImageUrl} alt="Misc" style={{ width: "50%" }} />}
                            </TableColumn>
                        </TableRow>

                        <TableRow>
                            <TableColumn>
                                <UploadFile
                                    label="Replace Client Login Image"
                                    accept={["image/png", "image/jpeg", "image/jpg"]}
                                    selectedFile={selectedClientImg}
                                    setSelectedFile={setSelectedClientImg}
                                    source="withoutCallingFileUploadAPI"
                                />
                                {selectedClientImg && (
                                    <Row>
                                        <StyledCheckmark
                                            onClick={() => handleCheckmarkClickVanityData("clientImage")}
                                        />

                                        <StyledCloseIcon
                                            onClick={() => {
                                                setSelectedClientImg(null);
                                            }}
                                        />
                                    </Row>
                                )}
                            </TableColumn>
                            <TableColumn>
                                {otherLoginUrl && <img src={otherLoginUrl} alt="BG" style={{ width: "50%" }} />}
                            </TableColumn>
                        </TableRow>

                        <TableRow>
                            <TableColumn>
                                <UploadFile
                                    label="Replace Client Logo Image"
                                    accept={["image/png", "image/jpeg", "image/jpg"]}
                                    selectedFile={selectedClientLogoImg}
                                    setSelectedFile={setSelectedClientLogoImg}
                                    source="withoutCallingFileUploadAPI"
                                />

                                {selectedClientLogoImg && (
                                    <Row>
                                        <StyledCheckmark
                                            onClick={() => handleCheckmarkClickVanityData("clientLogoImage")}
                                        />

                                        <StyledCloseIcon
                                            onClick={() => {
                                                setSelectedClientLogoImg(null);
                                            }}
                                        />
                                    </Row>
                                )}
                            </TableColumn>
                            <TableColumn>
                                {clientUrl && <img src={clientUrl} alt="BG" style={{ width: "50%" }} />}
                            </TableColumn>
                        </TableRow>

                        <TableRow>
                            <TableColumn>
                                <Label>SSO Metadata Json</Label>
                                <InputBox
                                    type="text"
                                    id="ssoMetadataJson"
                                    placeholder="Enter SSO Metadata Json"
                                    value={ssoMetadataJson}
                                    onClick={() => setIsJsonEditorOpenSSO(true)}
                                />
                            </TableColumn>
                        </TableRow>

                        <TableRow>
                            <TableColumn>
                                <TableColumn>
                                    <Label>Email Login (without guestMode this will ask for password creation)</Label>
                                    <ToggleSwitch
                                        value={emailLoginEnabled}
                                        onChange={(e) => handleVanityDataToogles(e, "emailLoginEnabled")}
                                    />
                                </TableColumn>
                            </TableColumn>
                            <TableColumn>
                                <Label>Facebook Login</Label>
                                <ToggleSwitch
                                    value={fbLoginEnabled}
                                    onChange={(e) => handleVanityDataToogles(e, "fbLoginEnabled")}
                                />
                            </TableColumn>
                            <TableColumn>
                                <Label>Google Login</Label>
                                <ToggleSwitch
                                    value={googleLoginEnabled}
                                    onChange={(e) => handleVanityDataToogles(e, "googleLoginEnabled")}
                                />
                            </TableColumn>
                            <TableColumn>
                                <Label>Twitter Login</Label>
                                <ToggleSwitch
                                    value={twiiterLoginEnabled}
                                    onChange={(e) => handleVanityDataToogles(e, "twiiterLoginEnabled")}
                                />
                            </TableColumn>
                        </TableRow>

                        <TableRow>
                            <TableColumn>
                                <Label> Spotify Login </Label>
                                <ToggleSwitch
                                    value={spotifyLoginEnabled}
                                    onChange={(e) => handleVanityDataToogles(e, "spotifyLoginEnabled")}
                                />
                            </TableColumn>
                            <TableColumn>
                                <Label> Other/Client Login </Label>
                                <ToggleSwitch
                                    value={otherLoginEnabled}
                                    onChange={(e) => handleVanityDataToogles(e, "otherLoginEnabled")}
                                />
                            </TableColumn>
                            <TableColumn>
                                <Label>Broadcast</Label>
                                <ToggleSwitch
                                    value={broadcast}
                                    onChange={(e) => handleVanityDataToogles(e, "broadcast")}
                                />
                            </TableColumn>
                            <TableColumn>
                                <Label>SSO</Label>
                                <ToggleSwitch value={sso} onChange={(e) => handleVanityDataToogles(e, "sso")} />
                            </TableColumn>
                        </TableRow>

                        <TableRow>
                            <TableColumn>
                                <Label>
                                    {" "}
                                    Guest Only Mode (Must be used with EmailLogin to remove password requirement){" "}
                                </Label>
                                <ToggleSwitch
                                    value={guestOnlyMode}
                                    onChange={(e) => handleVanityDataToogles(e, "guestOnlyMode")}
                                />
                            </TableColumn>

                            <TableColumn>
                                <Label> Marketing-Opt-In </Label>
                                <ToggleSwitch
                                    value={marketingOptIn}
                                    onChange={(e) => handleVanityDataToogles(e, "marketingOptIn")}
                                />
                            </TableColumn>
                            <TableColumn>{""} </TableColumn>
                            <TableColumn>{""} </TableColumn>
                        </TableRow>
                    </Table>
                )}
            </ModalContent>
            {isJsonEditorOpen && (
                <Modal
                    isOpen={isJsonEditorOpen}
                    setIsOpen={setIsJsonEditorOpen}
                    children={
                        <JsonViewerModal
                            jsonEditorValue={jsonEditorValue}
                            handleJsonSave={handleJsonSave}
                            fieldName={currentField}
                            label={currentFieldLabel}
                            closeModal={() => setIsJsonEditorOpen(false)}
                            action="Update"
                        />
                    }
                />
            )}
            {isJsonEditorOpenVanity && (
                <Modal
                    isOpen={isJsonEditorOpenVanity}
                    setIsOpen={setIsJsonEditorOpenVanity}
                    children={
                        <JsonViewerModal
                            jsonEditorValue={freeFormJson}
                            handleJsonSave={handleJsonSaveVanity}
                            fieldName={"freeFormJson"}
                            label={"FreeForm Json For Vanity Link"}
                            closeModal={() => setIsJsonEditorOpenVanity(false)}
                            action="Update"
                        />
                    }
                />
            )}

            {isJsonEditorOpenLinkData && (
                <Modal
                    isOpen={isJsonEditorOpenLinkData}
                    setIsOpen={setIsJsonEditorOpenLinkData}
                    children={
                        <JsonViewerModal
                            jsonEditorValue={freeFormJsonLinkData}
                            handleJsonSave={handleJsonSaveVanityData}
                            fieldName={"freeformJson"}
                            label={"FreeForm Json For Vanity Link Data"}
                            closeModal={() => setIsJsonEditorOpenLinkData(false)}
                            action="Update"
                        />
                    }
                />
            )}

            {isJsonEditorOpenSSO && (
                <Modal
                    isOpen={isJsonEditorOpenSSO}
                    setIsOpen={setIsJsonEditorOpenSSO}
                    children={
                        <JsonViewerModal
                            jsonEditorValue={ssoMetadataJson}
                            handleJsonSave={handleJsonSaveVanityData}
                            fieldName={"ssoMetadataJson"}
                            label={"SSO Metadata Json"}
                            closeModal={() => setIsJsonEditorOpenSSO(false)}
                            action="Update"
                        />
                    }
                />
            )}

            {openRoomTypeModal && (
                <Modal
                    isOpen={openRoomTypeModal}
                    setIsOpen={setOpenRoomTypeModal}
                    children={
                        <AddRoomTypeModal
                            setRoomType={setRoomType}
                            setIsSuccess={setIsSuccess}
                            setSuccessMessage={setSuccessMessage}
                            setErrorMessage={setErrorMessage}
                            setIsError={setIsError}
                            refetch={refetch}
                        />
                    }
                />
            )}

            {openRoomPrefabModal && (
                <Modal
                    isOpen={openRoomPrefabModal}
                    setIsOpen={setOpenRoomPrefabModal}
                    children={
                        <UpdateRoomPrefabModal
                            roomType={roomData?.roomType}
                            setOpenRoomPrefabModal={setOpenRoomPrefabModal}
                            setIsSuccess={setIsSuccess}
                            setSuccessMessage={setSuccessMessage}
                            setErrorMessage={setErrorMessage}
                            setIsError={setIsError}
                            refetch={refetch}
                        />
                    }
                />
            )}
        </>
    );
};

export default EditLinkModal;

const NavContainer = styled.div`
    display: flex;
    padding: 20px 40px;
    align-items: center;
    border-bottom: 1px solid #2a2a30;
`;

const Tab = styled.div`
    font-family: "Arial", sans-serif;
    font-size: 16px;
    letter-spacing: 2px;
    color: ${({ active }) => (active ? "#B9AFFF" : "#A0A0A0")};
    font-weight: 600;
    margin-right: 40px;
    cursor: pointer;
    position: relative;
    transition: color 0.3s ease;

    &:hover {
        color: #b9afff;
    }

    &::after {
        content: "";
        position: absolute;
        bottom: -25px;
        left: 0;
        width: ${({ active }) => (active ? "100%" : "0")};
        height: 4px;
        background-color: #b9afff;
        transition: width 0.3s ease;
    }
`;

const DropdownItem = styled.a`
    display: block;
    padding: 10px;
    font-weight: 700;
    width: 100%;
    font-family: "Barlow-Regular", Helvetica;
    cursor: pointer;
    color: ${(props) => (props.isSelected ? `${setColor.hightlight}` : `${setColor.inputText}`)};
    background: ${(props) => (props.isSelected ? `${setColor.pinkButtonBgGradient}` : "transparent")};
    letter-spacing: 0;
    line-height: normal;
    white-space: nowrap;
    margin: 0px;
    border-radius: 5px;
    &:hover {
        color: ${(props) => (props.isSelected ? `${setColor.hightlight}` : `${setColor.accent4}`)};
    }
`;

const ModalContent = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    width: 100%;
    color: ${setColor.inputText};
`;

const Table = styled.div`
    display: flex;
    flex-direction: column;
    padding: 1rem;
    border-radius: 5px;
`;

const TableRow = styled.div`
    display: flex;
    flex-direction: row;
    margin-bottom: 10px;
`;

const TableColumn = styled.div`
    flex: 1;
    padding: 5px;
`;

const Label = styled.div`
    font-weight: 600;
    font-size: 16px;
    margin-bottom: 10px;
`;

const InputBox = styled.input`
    padding: 10px;
    border: ${(props) => (props.errorMessage ? `1px solid ${setColor.errorColor}` : `1px solid ${setColor.grey1}`)};
    border-radius: 5px;
    color: ${setColor.inputText};
    margin: 0rem 0rem 0rem 0rem;
    width: ${(props) => (props.width ? props.width : "100%")};
    background-color: transparent;
    margin-bottom: ${(props) => (props.errorMessage ? "0.5rem" : "0rem")};
    &:disabled {
        background-color: ${setColor.grey1};
    }
`;

const StyledCheckmark = styled(Checkmark)`
    right: 15px;
    height: 20px;
    cursor: pointer;
    margin-top: 10px;
    &:hover {
        #Union {
            fill: ${setColor.greenLight};
        }
    }
`;

const TextP = styled.div`
    font-size: 14px;
`;

const Column = styled.div`
    margin-top: ${(props) => (props.errorMessage ? "1rem" : "0")};
    flex: ${(props) => (props.small ? "0.5" : "2")};
    width: ${(props) => (props.small ? "5%" : "95%")};
    @media (max-width: 768px) {
        flex: ${(props) => (props.small ? "1" : "2")};
    }
`;

const StyledCloseIcon = styled(Cross)`
    border-radius: 5px !important;
    width: 20px;
    height: 20px;
    cursor: pointer;
    margin-top: 10px;
    right: 10px;
    &:hover {
        #Union {
            fill: ${setColor.lightPink};
        }
    }
`;
const Row = styled.div`
    display: flex;
    margin: ${(props) => (props.marginBottom ? "1rem 0rem" : "0rem orem")};
`;
const LoadingDiv = styled.div`
    display: flex;
    margin-left: 5rem;
    margin-top: -1rem;
`;
const MessageDesc = styled.div`
    display: flex;
    margin-left: 5rem;
    margin-top: -1.5rem;
    color: ${(props) => (props.type === "success" ? setColor.successColor : setColor.errorColor)};
`;
const AvatarGrid = styled.div`
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(80px, 1fr));
    gap: 10px;
    justify-content: center;
    width: 100%;
    margin: 0 auto;
`;

const AvatarContainer = styled.div`
    position: relative;
    display: inline-block;
`;

const StyledImages = styled.img`
    width: 80px;
    height: auto;
    border-radius: 5px;
    margin: 5px;
    cursor: pointer;
    border: ${({ selected }) => (selected ? "3px solid #4CAF50" : "2px solid transparent")};
    transition: border 0.2s ease-in-out;
`;

const CheckmarkAvatar = styled.div`
    position: absolute;
    top: 5px;
    right: 5px;
    background-color: #4caf50;
    color: white;
    border-radius: 50%;
    width: 20px;
    height: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 14px;
    font-weight: bold;
`;

const KeybindContainer = styled.div`
    display: flex;
    gap: 8px;
    align-items: center;
    margin-bottom: 10px;
`;

const SelectBox = styled.select`
    padding: 10px 12px;
    border: 1px solid ${setColor.grey1};
    border-radius: 5px;
    color: ${setColor.inputText};
    background-color: ${setColor.inputBgColor};
    font-family: "Barlow-Regular", Helvetica;
    font-size: 14px;
    width: 180px;
    cursor: pointer;
    appearance: none;
    background-image: url("data:image/svg+xml;charset=UTF-8,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='%23FBFCFF' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3e%3cpolyline points='6 9 12 15 18 9'%3e%3c/polyline%3e%3c/svg%3e");
    background-repeat: no-repeat;
    background-position: right 10px center;
    background-size: 16px;
    padding-right: 36px;

    &:focus {
        outline: none;
        border-color: ${setColor.accent4};
        box-shadow: 0 0 0 2px ${setColor.purpleDark};
    }

    &:hover {
        border-color: ${setColor.accent4};
    }

    option {
        background-color: ${setColor.solidDarkPurpleBackground};
        color: ${setColor.inputText};
        padding: 12px;
        font-family: "Barlow-Regular", Helvetica;
        font-size: 14px;
    }

    option:hover,
    option:focus,
    option:checked {
        background-color: ${setColor.accent4};
        color: ${setColor.black};
    }
`;

const KeybindList = styled.ul`
    list-style: none;
    padding: 0;
    margin: 0;
`;

const KeybindItem = styled.li`
    font-family: "Barlow-Regular", Helvetica;
    font-size: 14px;
    color: ${setColor.inputText};
    margin-bottom: 5px;
    padding: 5px 0;
`;
